import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/nikolabroceta/projects/nikola_broceta_professional/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/nikolabroceta/projects/nikola_broceta_professional/src/components/common/Header.tsx");
